import {
  useSelector as reduxUseSelector,
  TypedUseSelectorHook
} from 'react-redux'
import type { AppState } from './contracts'

export const useSelector: TypedUseSelectorHook<AppState> = reduxUseSelector
export const getRootState = (state: AppState) => state
